import type { ConsumerCompanyRegistrationSnapshot, ValidateRutResponse } from "@/services/authService";

export type ManualCompanyFieldsState = {
  legalName: string;
  legalAddress: string;
  city: string;
  department: string;
  phone: string;
  email: string;
};

export const EMPTY_MANUAL_COMPANY_FIELDS: ManualCompanyFieldsState = {
  legalName: "",
  legalAddress: "",
  city: "",
  department: "",
  phone: "",
  email: "",
};

export function manualCompanyFieldsToValidateRutResponse(
  fields: ManualCompanyFieldsState,
): ValidateRutResponse {
  const legalName = fields.legalName.trim();
  return {
    legalName: legalName || "",
    legalAddress: fields.legalAddress.trim() || undefined,
    city: fields.city.trim() || undefined,
    department: fields.department.trim() || undefined,
    phone: fields.phone.trim() || undefined,
    email: fields.email.trim() || undefined,
  };
}

/** Maps B2C registration company snapshot to the same shape used after DGI validate-RUT. */
export function registrationSnapshotToValidateRutResponse(
  snap: ConsumerCompanyRegistrationSnapshot,
): ValidateRutResponse {
  return {
    legalName: snap.legalName.trim(),
    legalAddress: snap.legalAddress?.trim() || undefined,
    city: snap.city?.trim() || undefined,
    department: snap.department?.trim() || undefined,
    phone: snap.phone?.trim() || undefined,
    email: snap.contactEmail?.trim() || undefined,
  };
}
